module.exports = __webpack_public_path__ + "static/img/h17.2653274.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rural/tour1/h17.jpg
// module id = IHwn
// module chunks = 0